export default "__VITE_ASSET__1AeboHK7__"